import { render, staticRenderFns } from "./OrmQuoteRemarks.vue?vue&type=template&id=0190edd0&scoped=true"
import script from "./OrmQuoteRemarks.vue?vue&type=script&lang=js"
export * from "./OrmQuoteRemarks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0190edd0",
  null
  
)

export default component.exports